import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewerComponent } from './pages/viewer/viewer.component';
import { SearchFieldsComponent } from './pages/search-fields/search-fields.component';
import { ResultComponent } from './pages/result/result.component';
import { DocviewerComponent } from './pages/docviewer/docviewer.component'; 
import { DetailViewerComponent } from './pages/detail-viewer/detail-viewer.component'; 


const routes: Routes = [
  { path: '', component: SearchFieldsComponent},
  { path: 'search', component: SearchFieldsComponent},
  { path: 'viewer/:rtn', component: ViewerComponent},
  { path: 'results', component: ResultComponent},
  { path: 'detailviewer/:rtn/:category/:siteName/:aulInfo/:complianceStatus/:address/:date/:townName/:zipCode/:raoClass/:notificationDate/:locationType/:initailStatusDate/:source/:pipReceived/:regulateObjectId/:latitude/:longitude/:siteType/:phase', component: DetailViewerComponent},
  { path: 'detailviewer/:secondaryRTN', component: DetailViewerComponent},
  { path: 'docviewer/:downloadURL', component: DocviewerComponent,
  data: { showHeader: false, showFooter: false }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewerRoutingModule { }
